"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.listAndFilterCurrencies = exports.filterCurrencies = exports.listCurrencies = exports.isTokenCurrency = exports.isCryptoCurrency = void 0;
var minimatch_1 = require("minimatch");
var currencies_1 = require("../currencies");
var helpers_1 = require("../platform/helpers");
function isCryptoCurrency(currency) {
    return currency.type === "CryptoCurrency";
}
exports.isCryptoCurrency = isCryptoCurrency;
function isTokenCurrency(currency) {
    return currency.type === "TokenCurrency";
}
exports.isTokenCurrency = isTokenCurrency;
function listCurrencies(includeTokens) {
    var currencies = (0, currencies_1.listSupportedCurrencies)();
    if (!includeTokens) {
        return currencies;
    }
    var allTokens = (0, currencies_1.listTokens)().filter(function (_a) {
        var tokenType = _a.tokenType;
        return tokenType === "erc20" || tokenType === "bep20";
    });
    return __spreadArray(__spreadArray([], __read(currencies), false), __read(allTokens), false);
}
exports.listCurrencies = listCurrencies;
function filterCurrencies(currencies, filters) {
    var filterCurrencyRegexes = filters.currencies
        ? filters.currencies.map(function (filter) { return (0, minimatch_1.makeRe)(filter); })
        : null;
    return currencies.filter(function (currency) {
        if (!filters.includeTokens && isTokenCurrency(currency)) {
            return false;
        }
        if (filterCurrencyRegexes &&
            filterCurrencyRegexes.length &&
            !filterCurrencyRegexes.some(function (regex) { return currency.id.match(regex); })) {
            return false;
        }
        return true;
    });
}
exports.filterCurrencies = filterCurrencies;
function listAndFilterCurrencies(_a) {
    var _b = _a.includeTokens, includeTokens = _b === void 0 ? false : _b, currencies = _a.currencies;
    var allCurrencies = listCurrencies(includeTokens).filter(helpers_1.isPlatformSupportedCurrency);
    return filterCurrencies(allCurrencies, {
        includeTokens: includeTokens,
        currencies: currencies
    });
}
exports.listAndFilterCurrencies = listAndFilterCurrencies;
//# sourceMappingURL=helpers.js.map